import { render, staticRenderFns } from "./pinned_section.vue.js?vue&type=template&id=0aa4547c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pinned_section.vue?vue&type=template&id=0aa4547c"
import script from "./pinned_section.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pinned_section.vue?vue&type=script&lang=js"
export * from "./pinned_section.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pinned_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa4547c')) {
      api.createRecord('0aa4547c', component.options)
    } else {
      api.reload('0aa4547c', component.options)
    }
    module.hot.accept("./pinned_section.vue.js?vue&type=template&id=0aa4547c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pinned_section.vue?vue&type=template&id=0aa4547c", function () {
      api.rerender('0aa4547c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/pinned_section.vue"
export default component.exports